import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../hooks/useAuth';
import { signOutUser } from '../../../services/authService';
import './Header.css';

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const isActive = (path) => {
    // Handle both / and /dashboard as active for dashboard
    if (path === '/dashboard') {
      return location.pathname === '/' || location.pathname === '/dashboard';
    }
   return (
       location.pathname === path ||
       location.pathname.startsWith(`${path}/`)
     );
   };

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/auth');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <header className="header">
      <div className="header-content">
        <div className="header-left">
          <Link to="/dashboard" className="logo">
            <img src="/viralTrade_6_logo.png" alt="Viral Trade Logo" className="logo-icon" />
            <span className="logo-text">Viral Trade</span>
          </Link>
        </div>
      

        <nav className="header-nav">
          <Link 
            to="/dashboard" 
            className={`nav-link ${isActive('/dashboard') ? 'active' : ''}`}
          >
            Dashboard
          </Link>
          <Link 
            to="/analysis" 
            className={`nav-link ${isActive('/analysis') ? 'active' : ''}`}
          >
            Analysis
          </Link>
          <Link 
            to="/chat" 
            className={`nav-link ${isActive('/chat') ? 'active' : ''}`}
          >
            AI Chat
          </Link>
          <Link 
            to="/company-reports" 
            className={`nav-link ${isActive('/company-reports') ? 'active' : ''}`}
          >
            Report Analysis
          </Link>
          <Link 
            to="/news-analysis" 
            className={`nav-link ${isActive('/news-analysis') ? 'active' : ''}`}
          >
            News
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header; 
